import { Layout } from "antd";
import React, { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import LoadingPage from "views/Base/LoadingPage";
import { Content } from "antd/es/layout/layout";
import Receipts from "./DocumentsList/Receipts";

const DocumentsList = lazy(() => import("./DocumentsList"));
const Periodicals = lazy(() => import("./components/Periodicals"));

export default function Documents(): React.ReactElement {
  const { t } = useTranslation();
  const { subMenu } = useParams();

  const getDocumentProps = () => {
    switch (subMenu) {
      case "all":
        return { title: t("All"), key: "all" };
      case "budget":
        return { type: "budget", title: t("Budget"), key: "budget" };
      case "deliveries":
        return { type: "delivery_form", title: t("Deliveries"), key: "deliveries" };
      case "payment_in_advance":
        return {
          type: "payment_in_advance",
          title: t("Payment in advance"),
          key: "payment_in_advance",
        };
      case "invoices":
        return { type: "purchase_order", title: t("Invoices"), key: "invoices" };
      case "sale_order":
        return { type: "sale_order", title: t("Orders"), key: "sale_order" };
      case "assets":
        return { type: "return", title: t("Returns"), key: "assets" };
      default:
        return { title: t("All"), key: "all" };
    }
  };

  const { key, ...props } = getDocumentProps();

  const content = () => {
    if (subMenu === "periodicals") {
      return <Periodicals />;
    }
    if (subMenu === "receipt") {
      return <Receipts />;
    }
    return <DocumentsList key={key} {...props} />;
  };

  return (
    <Layout className="layout-card">
      <Content className="layout-card-content">
        <Suspense fallback={<LoadingPage />}>{content()}</Suspense>
      </Content>
    </Layout>
  );
}
